import React, { useEffect } from "react";
import {
  Modal,
  Box,
  Alert,
  Typography,
  IconButton,
  AlertTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../CSS/NotificationPopup.css"; // Import CSS file

const NotificationPopup = ({ open, onClose, message, severity, title }) => {
  const getBackgroundColor = (severity) => {
    switch (severity) {
      case "success":
        return "#d4edda";
      case "error":
        return "#f8d7da";
      case "warning":
        return "#fff3cd";
      case "info":
        return "#d1ecf1";
      default:
        return "background.paper";
    }
  };

  useEffect(() => {
    if (open) {
      const timer = setTimeout(onClose, 5000);
      return () => clearTimeout(timer);
    }
  }, [open, onClose]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        className="notification-popup-box"
        sx={{ bgcolor: getBackgroundColor(severity) }}
      >
        <Alert
          severity={severity}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={onClose}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {title && <AlertTitle>{title}</AlertTitle>}
          <Typography variant="h6">{message}</Typography>
        </Alert>
      </Box>
    </Modal>
  );
};

export default NotificationPopup;
